document.addEventListener('DOMContentLoaded', function () {
    const baseUrl = window.location.origin + window.location.pathname;
    console.log('Product base URL:', baseUrl);

    if (!window.ajoProduct) {
        console.warn('ajoProduct not found');
        return;
    }

    const product = window.ajoProduct;

    function getCurrentVariant() {
        const input = document.querySelector('form[action="/cart/add"] [name="id"]');
        if (!input) return null;

        const currentId = Number(input.value);
        if (!currentId) return null;

        return product.variants.find(v => v.id === currentId) || null;
    }

    let lastVariantId = null;

    function handleVariantChange(forceLog = false) {
        const variant = getCurrentVariant();
        if (!variant) {
            console.warn('Current variant not found');
            return;
        }

        if (!forceLog && variant.id === lastVariantId) {
            // Вариант не изменился — ничего не делаем
            return;
        }

        lastVariantId = variant.id;

        console.log('=== Variant changed ===');
        console.log('ID:', variant.id);
        console.log('Title:', variant.title);
        console.log('Опции:', variant.option1, variant.option2, variant.option3);
        console.log('Цена (в центах):', variant.price);

    }

    // 1) При первой загрузке – зафиксировать текущее состояние
    handleVariantChange(true);

    // 2) Периодически проверяем, не поменялся ли variant ID
    setInterval(function () {
        handleVariantChange(false);
    }, 500); 
});
